// import React, { useState, useEffect } from "react";
// import { FaSmile, FaPaperPlane } from "react-icons/fa";
// import axios from "axios";
// import EmojiPicker from "emoji-picker-react";


// const SendGroupMessage = () => {
//     const groupList = [
//         "Y2FwaV9ncm91cDo5MTg5MTkxNzE5ODU6MTIwMzYzNDA0NTQyMTcwODAy",
//     ];

//     const [selectedGroup, setSelectedGroup] = useState("");
//     const [pid, setPid] = useState(null);
//     const [message, setMessage] = useState("");

//     // ⭐ LOAD PID FROM SESSION STORAGE (Your same logic)
//     useEffect(() => {
//         const loggedUser = JSON.parse(sessionStorage.getItem("user"));
//         if (!loggedUser) return;

//         const emailToUse =
//             loggedUser.role === "admin" ? loggedUser.email : loggedUser.adminEmail;

//         axios
//             .get(
//                 `https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(
//                     emailToUse
//                 )}`
//             )
//             .then((response) => {
//                 const userData = response.data;
//                 if (userData.p_id) {
//                     setPid(userData.p_id);
//                 }
//             })
//             .catch((err) => console.error("Error retrieving user data:", err));
//     }, []);

//     // ⭐ SEND GROUP MESSAGE API
//     const sendMessage = async () => {
//         if (!selectedGroup) return alert("Please select a group!");
//         if (!pid) return alert("PID not loaded!");
//         if (!message.trim()) return alert("Enter a message!");

//         const payload = {
//             pid: pid.toString(),
//             groupId: selectedGroup,
//             message: message,
//         };

//         const response = await fetch(
//             "https://emedha.com/echatbot/enotifier/groups/sendGroupMessage.php",
//             {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify(payload),
//             }
//         );

//         const data = await response.json();
//         console.log("API Response:", data);

//         alert("Message Sent Successfully!");
//         setMessage("");
//     };


//     const [showEmoji, setShowEmoji] = useState(false);

//     const handleEmojiClick = (emojiData) => {
//         setMessage((prev) => prev + emojiData.emoji);
//     };



//     return (
//         <div style={styles.container}>
//             <h2 style={styles.title}>Send Group Message</h2>

//             {/* Group Dropdown */}
//             <select
//                 style={styles.dropdown}
//                 value={selectedGroup}
//                 onChange={(e) => setSelectedGroup(e.target.value)}
//             >
//                 <option value="">Select Group ID</option>
//                 {groupList.map((g, i) => (
//                     <option key={i} value={g}>
//                         {g}
//                     </option>
//                 ))}
//             </select>

//             {/* PID Display */}
//             <div style={styles.pidBox}>
//                 <strong>Your PID:</strong>{" "}
//                 {pid ? <span style={styles.pid}>{pid}</span> : "Loading..."}
//             </div>

//             {/* Message Input */}
//             <div style={styles.messageBox}>
//                 <textarea
//                     style={styles.textArea}
//                     rows={4}
//                     placeholder="Type your message... 😊🔥💬"
//                     value={message}
//                     onChange={(e) => setMessage(e.target.value)}
//                 />

//                 {/* Emoji button (optional future popup) */}
//                 {/* <FaSmile style={styles.emojiIcon} /> */}
//                 <div style={{ position: "relative" }}>
//                     <button
//                         type="button"
//                         onClick={() => setShowEmoji(!showEmoji)}
//                         style={{
//                             marginRight: "10px",
//                             fontSize: "22px",
//                             background: "none",
//                             border: "none",
//                             cursor: "pointer",
//                         }}
//                     >
//                         😊
//                     </button>

//                     {showEmoji && (
//                         <div style={{ position: "absolute", bottom: "50px", zIndex: 999 }}>
//                             <EmojiPicker onEmojiClick={handleEmojiClick} />
//                         </div>
//                     )}
//                 </div>

//             </div>

//             {/* Send Button */}
//             <button style={styles.sendBtn} onClick={sendMessage}>
//                 <FaPaperPlane style={{ marginRight: 8 }} />
//                 Send Message
//             </button>
//         </div>
//     );
// };

// export default SendGroupMessage;

// // -------------------- STYLES --------------------
// const styles = {
//     container: {
//         width: "90%",
//         maxWidth: "600px",
//         margin: "20px auto",
//         padding: "20px",
//         background: "#ffffff",
//         borderRadius: "16px",
//         boxShadow: "0 5px 25px rgba(0,0,0,0.08)",
//         fontFamily: "Poppins",
//     },

//     title: {
//         marginBottom: "10px",
//         color: "#0158a2",
//         fontSize: "22px",
//         fontWeight: "600",
//         textAlign: "center",
//     },

//     dropdown: {
//         width: "100%",
//         padding: "12px",
//         borderRadius: "12px",
//         border: "1px solid #ccc",
//         marginBottom: "12px",
//         fontSize: "16px",
//     },

//     pidBox: {
//         background: "#f0f7ff",
//         padding: "12px",
//         borderRadius: "10px",
//         marginBottom: "15px",
//         fontSize: "16px",
//         border: "1px solid #bcd7ff",
//     },

//     pid: {
//         color: "#0158a2",
//         fontWeight: "700",
//     },

//     messageBox: {
//         position: "relative",
//     },

//     textArea: {
//         width: "100%",
//         padding: "12px",
//         borderRadius: "12px",
//         border: "1px solid #ccc",
//         fontSize: "16px",
//         resize: "none",
//         outline: "none",
//         fontFamily: "Poppins",
//     },

//     emojiIcon: {
//         position: "absolute",
//         right: "12px",
//         bottom: "12px",
//         fontSize: "22px",
//         cursor: "pointer",
//         color: "#666",
//     },

//     sendBtn: {
//         width: "100%",
//         padding: "14px",
//         background: "#0158a2",
//         color: "#fff",
//         border: "none",
//         borderRadius: "12px",
//         marginTop: "15px",
//         cursor: "pointer",
//         fontSize: "17px",
//         fontWeight: "600",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//     },
// };


// import React, { useState, useEffect } from "react";
// import { FaPaperPlane } from "react-icons/fa";
// import axios from "axios";
// import EmojiPicker from "emoji-picker-react";

// const SendGroupMessage = () => {
//   const [groups, setGroups] = useState([]);
//   const [selectedGroup, setSelectedGroup] = useState("");
//   const [pid, setPid] = useState(null);
//   const [message, setMessage] = useState("");
//   const [showEmoji, setShowEmoji] = useState(false);

//   // ----------------------------------------------------
//   // 1️⃣ LOAD PID FROM SESSION STORAGE
//   // ----------------------------------------------------
//   useEffect(() => {
//     const loggedUser = JSON.parse(sessionStorage.getItem("user"));
//     if (!loggedUser) return;

//     const emailToUse =
//       loggedUser.role === "admin" ? loggedUser.email : loggedUser.adminEmail;

//     axios
//       .get(
//         `https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(
//           emailToUse
//         )}`
//       )
//       .then((response) => {
//         const userData = response.data;
//         if (userData.p_id) {
//           setPid(userData.p_id);
//           fetchGroups(userData.p_id);
//         }
//       })
//       .catch((err) => console.error("PID Load Error:", err));
//   }, []);

//   // ----------------------------------------------------
//   // 2️⃣ FETCH ALL GROUPS AUTOMATICALLY
//   // ----------------------------------------------------
//   const fetchGroups = async (pidValue) => {
//     try {
//       const res = await axios.post(
//         "https://emedha.com/echatbot/enotifier/groups/getAllGroups.php",
//         {
//           pid: pidValue,
//           limit: 50,
//           after: "",
//           before: "",
//         },
//         { headers: { "Content-Type": "application/json" } }
//       );

//       setGroups(res.data.data || []);
//     } catch (err) {
//       console.error("Error fetching groups:", err);
//     }
//   };

//   // ----------------------------------------------------
//   // 3️⃣ SEND GROUP MESSAGE API
//   // ----------------------------------------------------
//   const sendMessage = async () => {
//     if (!selectedGroup) return alert("Please select a group!");
//     if (!pid) return alert("PID not loaded!");
//     if (!message.trim()) return alert("Enter a message!");

//     const payload = {
//       pid: pid.toString(),
//       groupId: selectedGroup,
//       message: message,
//     };

//     const response = await fetch(
//       "https://emedha.com/echatbot/enotifier/groups/sendGroupMessage.php",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       }
//     );

//     const data = await response.json();
//     console.log("Send Msg Response:", data);

//     alert("Message Sent Successfully!");
//     setMessage("");
//   };

//   const handleEmojiClick = (emojiData) => {
//     setMessage((prev) => prev + emojiData.emoji);
//   };

//   // ----------------------------------------------------
//   // UI STARTS HERE
//   // ----------------------------------------------------
//   return (
//     <div style={styles.container}>
//       <h2 style={styles.title}>Send Group Message</h2>

//       {/* GROUP DROPDOWN */}
//       <select
//         style={styles.dropdown}
//         value={selectedGroup}
//         onChange={(e) => setSelectedGroup(e.target.value)}
//       >
//         <option value="">Select Group</option>

//         {groups.map((g) => (
//           <option key={g.id} value={g.id}>
//             {g.subject} 
//             {/* ({g.id}) */}
//           </option>
//         ))}
//       </select>

//       {/* PID DISPLAY */}
//       <div style={styles.pidBox}>
//         <strong>Your PID:</strong>{" "}
//         {pid ? <span style={styles.pid}>{pid}</span> : "Loading..."}
//       </div>

//       {/* MESSAGE INPUT + EMOJI */}
//       <div style={{ position: "relative" }}>
//         <textarea
//           style={styles.textArea}
//           rows={4}
//           placeholder="Type your message... 😊🔥💬"
//           value={message}
//           onChange={(e) => setMessage(e.target.value)}
//         />

//         {/* Emoji Button */}
//         <button
//           type="button"
//           onClick={() => setShowEmoji(!showEmoji)}
//           style={styles.emojiBtn}
//         >
//           😊
//         </button>

//         {/* Emoji Picker Popup */}
//         {showEmoji && (
//           <div style={styles.emojiPicker}>
//             <EmojiPicker onEmojiClick={handleEmojiClick} />
//           </div>
//         )}
//       </div>

//       {/* SEND BUTTON */}
//       <button style={styles.sendBtn} onClick={sendMessage}>
//         <FaPaperPlane style={{ marginRight: 8 }} />
//         Send Message
//       </button>
//     </div>
//   );
// };

// export default SendGroupMessage;

// // --------------------------------------------------
// // UI STYLING
// // --------------------------------------------------
// const styles = {
//   container: {
//     width: "90%",
//     maxWidth: "600px",
//     margin: "20px auto",
//     padding: "20px",
//     background: "#ffffff",
//     borderRadius: "16px",
//     boxShadow: "0 5px 25px rgba(0,0,0,0.08)",
//     fontFamily: "Poppins",
//   },

//   title: {
//     color: "#0158a2",
//     textAlign: "center",
//     fontSize: "22px",
//     fontWeight: "600",
//     marginBottom: "15px",
//   },

//   dropdown: {
//     width: "100%",
//     padding: "12px",
//     borderRadius: "12px",
//     border: "1px solid #ccc",
//     fontSize: "15px",
//     marginBottom: "12px",
//   },

//   pidBox: {
//     background: "#f0f7ff",
//     padding: "12px",
//     borderRadius: "10px",
//     border: "1px solid #bcd7ff",
//     marginBottom: "15px",
//     fontSize: "16px",
//   },

//   pid: {
//     color: "#0158a2",
//     fontWeight: "700",
//   },

//   textArea: {
//     width: "100%",
//     padding: "12px",
//     borderRadius: "12px",
//     border: "1px solid #ccc",
//     fontSize: "16px",
//     fontFamily: "Poppins",
//     resize: "none",
//   },

//   emojiBtn: {
//     position: "absolute",
//     right: "10px",
//     bottom: "10px",
//     background: "none",
//     border: "none",
//     fontSize: "22px",
//     cursor: "pointer",
//   },

//   emojiPicker: {
//     position: "absolute",
//     bottom: "60px",
//     right: "0",
//     zIndex: 10,
//   },

//   sendBtn: {
//     marginTop: "15px",
//     width: "100%",
//     background: "#0158a2",
//     padding: "14px",
//     color: "#fff",
//     fontSize: "17px",
//     borderRadius: "12px",
//     border: "none",
//     cursor: "pointer",
//     fontWeight: "600",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//   },
// };


import React, { useState, useEffect } from "react";
import { MessageCircle, Send } from "lucide-react";
import axios from "axios";
import EmojiPicker from "emoji-picker-react";

export default function SendGroupMessage() {
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [pid, setPid] = useState(null);
  const [message, setMessage] = useState("");
  const [showEmoji, setShowEmoji] = useState(false);

  // ----------------------------------------------------
  // 1️⃣ LOAD PID FROM SESSION STORAGE
  // ----------------------------------------------------
  useEffect(() => {
    const loggedUser = JSON.parse(sessionStorage.getItem("user"));
    if (!loggedUser) return;

    const emailToUse =
      loggedUser.role === "admin" ? loggedUser.email : loggedUser.adminEmail;

    axios
      .get(
        `https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(
          emailToUse
        )}`
      )
      .then((response) => {
        const userData = response.data;
        if (userData.p_id) {
          setPid(userData.p_id);
          fetchGroups(userData.p_id);
        }
      })
      .catch((err) => console.error("PID Load Error:", err));
  }, []);

  // ----------------------------------------------------
  // 2️⃣ FETCH ALL GROUPS AUTOMATICALLY
  // ----------------------------------------------------
  const fetchGroups = async (pidValue) => {
    try {
      const res = await axios.post(
        "https://emedha.com/echatbot/enotifier/groups/getAllGroups.php",
        {
          pid: pidValue,
          limit: 50,
          after: "",
          before: "",
        },
        { headers: { "Content-Type": "application/json" } }
      );

      setGroups(res.data.data || []);
    } catch (err) {
      console.error("Error fetching groups:", err);
    }
  };

  // ----------------------------------------------------
  // 3️⃣ SEND GROUP MESSAGE API
  // ----------------------------------------------------
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevents page reload

    if (!selectedGroup) return alert("Please select a group!");
    if (!pid) return alert("PID not loaded!");
    if (!message.trim()) return alert("Enter a message!");

    const payload = {
      pid: pid.toString(),
      groupId: selectedGroup,
      message: message,
    };

    try {
      const response = await fetch(
        "https://emedha.com/echatbot/enotifier/groups/sendGroupMessage.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();
      console.log("Send Msg Response:", data);

      alert("Message Sent Successfully!");
      setMessage("");
      setShowEmoji(false);
    } catch (error) {
      console.error("Error sending message:", error);
      alert("Failed to send message. Please try again.");
    }
  };

  const handleEmojiClick = (emojiData) => {
    setMessage((prev) => prev + emojiData.emoji);
  };

  // ----------------------------------------------------
  // UI DESIGN STRUCTURE
  // ----------------------------------------------------
  return (
    <div style={styles.pageWrapper}>
      {/* Page Header Layout */}
      <div style={styles.header}>
        <div>
          <h1 style={styles.title}>
            <MessageCircle size={22} style={{ color: "#2563eb" }} />
            Send Group Message
          </h1>
          <div style={styles.subtitle}>
            <p>Your PID: {pid ? pid : "Loading..."}</p>
          </div>
        </div>
      </div>

      {/* Main Form Box */}
      <form onSubmit={handleSubmit} style={styles.formCard}>
        <h2 style={styles.formTitle}>Send Group Message</h2>

        <div style={styles.grid}>
          {/* Dynamic Group Dropdown Field */}
          <div style={styles.fieldGroup}>
            <label style={styles.label}>
              Select Group <span style={styles.requiredStar}>*</span>
            </label>
            <select
              style={styles.select}
              value={selectedGroup}
              onChange={(e) => setSelectedGroup(e.target.value)}
              required
            >
              <option value="" disabled>-- Choose a Group --</option>
              {groups.map((g) => (
                <option key={g.id} value={g.id}>
                  {g.subject}
                </option>
              ))}
            </select>
          </div>

          {/* Message Content Textarea with Emoji Picker Layer */}
          <div style={styles.fieldGroup}>
            <label style={styles.label}>
              Message <span style={styles.requiredStar}>*</span>
            </label>
            <div style={styles.textareaContainer}>
              <textarea
                style={styles.textarea}
                placeholder="Type your message here... 😊"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
              />

              {/* Emoji Activation Button */}
              <button
                type="button"
                onClick={() => setShowEmoji(!showEmoji)}
                style={styles.emojiBtn}
              >
                😊
              </button>

              {/* Popup Overlay Panel */}
              {showEmoji && (
                <div style={styles.emojiPicker}>
                  <EmojiPicker onEmojiClick={handleEmojiClick} />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Action Dispatch Triggers */}
        <div style={styles.actionsContainer}>
          <button type="submit" style={styles.primaryBtn}>
            <Send size={14} />
            Send Message
          </button>
        </div>
      </form>
    </div>
  );
}

// --------------------------------------------------
// EXACT ALIGNED INLINE DESIGN STYLES
// --------------------------------------------------
const styles = {
  pageWrapper: {
    padding: "10px",
    fontFamily: "Arial, sans-serif",
    maxWidth: "600px",
    margin: "0 auto",
    backgroundColor: "#f9fafb",
    borderRadius: "8px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "20px",
  },
  title: {
    fontSize: "24px",
    fontWeight: "bold",
    margin: 0,
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  subtitle: {
    fontSize: "12px",
    color: "#6b7280",
    marginTop: "4px",
  },
  formCard: {
    backgroundColor: "#ffffff",
    padding: "24px",
    borderRadius: "8px",
    border: "1px solid #e5e7eb",
  },
  formTitle: {
    fontSize: "18px",
    fontWeight: "600",
    marginBottom: "16px",
    color: "#111827",
  },
  grid: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  fieldGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  label: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#374151",
  },
  requiredStar: {
    color: "#ef4444",
    marginLeft: "4px",
  },
  select: {
    width: "100%",
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #d1d5db",
    backgroundColor: "#fff",
    fontSize: "14px",
    outline: "none",
    boxSizing: "border-box",
  },
  textareaContainer: {
    position: "relative",
    width: "100%",
  },
  textarea: {
    width: "100%",
    padding: "10px",
    paddingRight: "46px", // Keeps text from overlapping the emoji trigger
    borderRadius: "6px",
    border: "1px solid #d1d5db",
    fontSize: "14px",
    minHeight: "100px",
    resize: "vertical",
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "Arial, sans-serif",
  },
  emojiBtn: {
    position: "absolute",
    right: "12px",
    bottom: "12px",
    background: "none",
    border: "none",
    fontSize: "20px",
    cursor: "pointer",
    outline: "none",
  },
  emojiPicker: {
    position: "absolute",
    bottom: "50px",
    right: "0",
    zIndex: 999,
  },
  actionsContainer: {
    display: "flex",
    gap: "8px",
    marginTop: "20px",
  },
  primaryBtn: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    backgroundColor: "#2563eb",
    color: "#ffffff",
    padding: "10px 16px",
    borderRadius: "6px",
    border: "none",
    fontWeight: "500",
    fontSize: "14px",
    cursor: "pointer",
    transition: "background-color 0.2s",
  },
};